import React from 'react';
import { Box } from '@mui/material';

export default function Overview() {
    return (
        <Box sx={{ padding: 3, textAlign: 'center' }}>
            <h3 style={{ color: '#666' }}>OVERVIEW</h3>
            <p style={{ color: '#999' }}>Coming soon...</p>
        </Box>
    );
}
